export enum MenuTypes {
  LoggedIn = 'LoggedIn',
  LoggedOut = 'LoggedOut'
}

export interface SingleLink {
  name: string;
  link?: string;
  class?: string;
  desktop?: boolean;
}

export interface MenuItem {
  header: string;
  links: SingleLink[];
}

export interface Button {
  url: string;
  text: string;
  styles: string;
}

export interface Menu {
  depositBtn: string;
  langOptions: string;
  showMoreBtn?: string;
  showLessBtn?: string;
  menuItems: MenuItem[];
  buttons?: Button[];
}

export type MenuConfig = {
  [key in MenuTypes]: Menu;
};
